@if (companySettings$ | async; as companySettings) {
  <div class="logo">
    @if (isMobileMenu()) {
      @if (companySettings?.logo) {
        <div class="logo-img">
          <img [src]="companySettings.logo" />
        </div>
      }
      {{ companySettings?.name }}
    } @else {
      <a [href]="companySettings?.url" class="simple-text">

      @if (companySettings?.logo) {
        <div class="logo-img">
          <img [src]="companySettings.logo" />
        </div>
      }
      {{ companySettings?.name }}
      </a>
    }
  </div>
}
<div class="sidebar-wrapper">
  @if (isMobileMenu()) {
    <button
      type="button"
      class="mobile-close-button"
      (click)="closeMobileSidebar($event)"
      aria-label="Menü schließen"
    >
      <fa-icon [icon]="icon('close')"></fa-icon>
    </button>
    <div>
      <ul class="nav navbar-nav nav-mobile-menu">
        <li class="nav-item">
          <a class="nav-link" (click)="closeMobileSidebar($event); logout()">
            <fa-icon [icon]="icon('person')"></fa-icon>
            <p>
              <span class="d-lg-none d-md-block">Logout</span>
            </p>
          </a>
        </li>
      </ul>
    </div>
  }
  @if (user) {
    <ul class="nav">
      <li class="collapsing-nav-item">
        <a class="nav-link">
          <p><fa-icon [icon]="icon('bar_chart')"></fa-icon>Übersichten</p>
        </a>
        <ul class="list-none">
          <li routerLinkActive="active" nav-item>
            <a class="nav-link" [routerLink]="['/overview']" (click)="closeMobileSidebar($event)">
              <p><fa-icon [icon]="icon('calendar_view_day')"></fa-icon>Übersicht</p>
            </a>
          </li>
          <li routerLinkActive="active" nav-item>
            <a class="nav-link" [routerLink]="['/working-year']" (click)="closeMobileSidebar($event)">
              <p><fa-icon [icon]="icon('event_note')"></fa-icon> Dieses Jahr</p>
            </a>
          </li>
          <li routerLinkActive="active" nav-item>
            <a class="nav-link" [routerLink]="['/working-month']" (click)="closeMobileSidebar($event)">
              <p><fa-icon [icon]="icon('date_range')"></fa-icon> Dieser Monat</p>
            </a>
          </li>
          <li routerLinkActive="active" nav-item>
            <a class="nav-link" [routerLink]="['/working-day']" (click)="closeMobileSidebar($event)">
              <p><fa-icon [icon]="icon('today')"></fa-icon> Heute</p>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  }
  @if (user) {
    <ul class="nav">
      @for (menuItem of filteredUserMenuItems; track menuItem.path) {
        <li
          routerLinkActive="active"
          class="{{ menuItem.class }} nav-item"
        >
          <a class="nav-link" [routerLink]="[menuItem.path]" (click)="closeMobileSidebar($event)">
            <p>
              <fa-icon [icon]="icon(menuItem.icon)"></fa-icon> {{ menuItem.title }}
              @if (menuItem.path === '/leave-requests/pending' && canApproveLeaveRequests) {
                @if (pendingLeaveRequests$ | async; as pendingCount) {
                  @if (pendingCount > 0) {
                    <span class="badge badge-pill badge-danger ml-2">
                      {{ pendingCount }}
                    </span>
                  }
                }
              }
            </p>
          </a>
        </li>
      }
    </ul>
  }
  @if (user && isAdministrator && !isMobileDevice) {
    <hr />
  }
  @if (isAdministrator && !isMobileDevice) {
    <ul class="nav">
      @for (menuItem of adminMenuItems; track menuItem.path) {
        <li
          routerLinkActive="active"
          class="{{ menuItem.class }} nav-item"
        >
          <a class="nav-link" [routerLink]="[menuItem.path]" (click)="closeMobileSidebar($event)">
            <p>
              <fa-icon [icon]="icon(menuItem.icon)"></fa-icon> {{ menuItem.title }}
            </p>
          </a>
        </li>
      }
    </ul>
  }
  @if (user && isAdministrator && !isMobileDevice) {
    <hr />
  }
  @if (isAdministrator && !isMobileDevice) {
    <ul class="nav">
      @for (menuItem of settingsMenuItems; track menuItem.path) {
        <li
          routerLinkActive="active"
          class="{{ menuItem.class }} nav-item"
        >
          <a class="nav-link" [routerLink]="[menuItem.path]" (click)="closeMobileSidebar($event)">
            <p>
              <fa-icon [icon]="icon(menuItem.icon)"></fa-icon> {{ menuItem.title }}
            </p>
          </a>
        </li>
      }
    </ul>
  }
</div>
